import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import { Badge } from "@/components/ui/badge";

export default function CaseStudies() {
  useSeo({ title: "Case Studies", description: "In-depth Buddy Solution case studies showing our approach and outcomes." });
  const { data: items = [] } = useQuery({ queryKey: ["case-studies"], queryFn: async () => (await api.get("/case-studies")).data });

  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Case studies" title="Deep dives into our work"
        subtitle="How we approach real problems and the outcomes we deliver. Client names confidential where required." /></Reveal>

      <div className="mt-14 space-y-8">
        {items.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.05}>
            <Link to={`/portfolio/${p.slug}`} data-testid={`case-study-${p.slug}`}
              className="group grid gap-6 overflow-hidden bs-card lg:grid-cols-2 hover:shadow-soft">
              <div className={`overflow-hidden ${i % 2 ? "lg:order-2" : ""}`}>
                <img src={p.image} alt={p.title} className="h-full min-h-[240px] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex flex-col justify-center p-8">
                <Badge variant="secondary" className="w-fit">{p.category}</Badge>
                <h2 className="mt-3 font-display text-2xl font-bold">{p.title}</h2>
                <p className="mt-3 text-muted-foreground">{p.summary}</p>
                {p.results?.length > 0 && (
                  <div className="mt-4 space-y-2">
                    {p.results.map((r) => <p key={r} className="flex items-start gap-2 text-sm"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-success" /> {r}</p>)}
                  </div>
                )}
                <span className="mt-5 inline-flex items-center text-sm font-semibold text-primary">Read case study <ArrowRight className="ml-1 h-4 w-4" /></span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
